import React, { useCallback, useMemo } from 'react';

import { useModalContext } from '@/common/contexts/ModalContext';
import PrintPage from '@/ebat/components/blocks/Modal/Product/PrintPage/PrintPage';

const useLinks = ({ hasPrint, links, video }) => {
  const {
    onOpenModal,
    setModalClassName,
    setModalContent,
    setModalSize,
  } = useModalContext();

  const hasLinks = useMemo(
    () => Object.keys(links).length > 0 || video || hasPrint,
    [hasPrint, links, video],
  );

  const handleOpenModal = useCallback(
    (type) => {
      switch (type) {
        case 'PrintPage':
          setModalContent(<PrintPage />);
          setModalClassName('modal-print-page');
          setModalSize('sm');
          break;
        default:
          return null;
      }

      return onOpenModal();
    },
    [onOpenModal, setModalClassName, setModalContent, setModalSize],
  );

  return {
    handleOpenModal,
    hasLinks,
  };
};

export default useLinks;
